import { isFunc } from "../fn";

const join = path => (Array.isArray(path) ? path.join(".") : path);

export class GqlError extends Error {
	name = "GqlError";

	isGraphQlError = true;

	constructor(originalError) {
		const { code, message, path } = originalError;
		super(`GraphQL Error in ${join(path)}: ${code} - ${message}`);

		this.code = code;
		this.path = join(path);
		this.originalError = originalError;
	}
}

/**
 * Creates predicate to match Expected GqlErrors.
 */
export const isExpectedGqlError = (...expected) => err =>
	err?.isGraphQlError === true && (expected.length === 0 || expected.includes(err.code));

const toCode = value => {
	const code = +value;
	return Number.isNaN(code) ? value : code;
};

/**
 * Maps expected GQL Error to other value
 */
export const mapGqlError = codeMap => {
	const isExpected = isExpectedGqlError(...Object.keys(codeMap).map(toCode));
	return error => {
		if (!isExpected(error)) throw error;
		const mappedValue = codeMap[error.code];
		return isFunc(mappedValue) ? mappedValue(error) : mappedValue;
	};
};
